import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { serviceUrl } from '../config'
import { Cookies } from 'react-cookie'

export const jachtApi = createApi({
    reducerPath: 'jachtApi',
    baseQuery: fetchBaseQuery({
        baseUrl: serviceUrl,
        prepareHeaders: (headers) => {

            const token = new Cookies().get('token');

           if (token) {
             headers.set('authorization', `Bearer ${token}`)
           }
           return headers
        }
    }),
    tagTypes: ['jacht'],
    endpoints: (builder) => ({
        jacht: builder.query({
            query: (arg) => {

                if(arg==undefined){
                    return { url: '/jacht/', method: 'GET' }
                } else {
                    return { url: `/jacht/${arg}`, method: 'GET' }
                }
            },

        }),
        addJacht: builder.mutation({
            query: (page) => ({
                url: '/jacht/',
                method: 'POST',
                body: page
            }),
            invalidatesTags: ['jacht']
        }),
        updateJacht: builder.mutation({
            query: ({ id, rest }) => ({
                url: `/jacht/${id}`,
                method: 'PUT',
                body: rest
            }),
            invalidatesTags: ['jacht']
        }),
        deleteJacht: builder.mutation({
            query: (id) => ({
                url: `/jacht/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['jacht']
        })
    })
});

export const { useJachtQuery, useAddJachtMutation, useUpdateJachtMutation, useDeleteJachtMutation } = jachtApi;
